import { FetchResourceCollectionOK } from '../types/FetchResourceCollectionOK'
import { Resource } from '../types/Resource'
import isErrorDocument from './isErrorDocument'

export default <R extends Resource>(japiDocument: any): japiDocument is FetchResourceCollectionOK<R> => typeof japiDocument === 'object' && !isErrorDocument(japiDocument) && Array.isArray(japiDocument.data); // eslint-disable-line
